interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}

const PageHeader = ({ eyebrow, title, subtitle }: Props) => (
  <section className="border-b border-border bg-secondary">
    <div className="container-wide py-16 md:py-24">
      {eyebrow && (
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-accent">
          {eyebrow}
        </p>
      )}
      <h1 className="max-w-3xl font-serif text-4xl font-semibold leading-tight text-primary md:text-5xl lg:text-6xl">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted-foreground">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHeader;
